const mobile = 375;
const tablet = 765;
const wpDesktop = 783;
const laptop = 1025;
const wide = 1440;

module.exports = {
  tablet,
  laptop,
  wide,
  customMedia: {
    "--mobile": `(min-width: ${mobile}px)`,
    "--tablet": `(min-width: ${tablet}px)`,
    "--wp-desktop": `(min-width: ${wpDesktop}px)`,
    "--up-to-laptop": `(min-width: ${laptop - 1}px)`,
    "--laptop": `(min-width: ${laptop}px)`,
    "--wide": `(min-width: ${wide}px)`,
    "--good-ratio": `(max-aspect-ratio: 128/69)`,
  },
};
